import { useEffect } from "react";

const useAnalytics = (trackingId) => {
  useEffect(() => {
    // Check if gtag script already exists
    if (!window.gtag) {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
      document.head.appendChild(script);

      const inlineScript = document.createElement("script");
      inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${trackingId}');
      `;
      document.head.appendChild(inlineScript);
    } else {
      window.gtag("config", trackingId);
    }
  }, [trackingId]); // Runs only when the component mounts
};

export default useAnalytics;
